import { FilePickerViewType } from '../types/FilePickerViewSwitcher';
import { FileSelectionFilter } from 'owa-fileprovider-store';
import { createStore } from 'satcheljs';
var filePickerStoreData = {
    viewState: {
        isOpen: false,
        fileSelectionFilter: FileSelectionFilter.None,
        selectedFileProvider: null,
        selectedProviderScope: null,
        filePickerViewState: {
            breadcrumbs: [],
            columnSorting: null,
            fileProviderItems: [],
            isLoadingItems: false,
            pagingMetadata: null,
            selectedFileProviderItems: [],
            selectedFolder: null,
            selectedView: null,
            supportedActions: [],
            supportedActionsMessages: [],
            supportedViews: [],
            totalItemsCount: 0,
            userPreferredViewType: FilePickerViewType.List,
            searchViewState: {
                searchQuery: '',
                isInSearchMode: false,
            },
            filterOptionsState: {
                showFilterOptions: false,
                selectedFilterOption: 0 /* None */,
            },
        },
        fileProviderPaneViewState: {
            fileProvidersToDisplay: [],
        },
        filePickerErrorMessageViewState: {
            isShown: false,
            message: null,
        },
        filePickerActionsViewState: {
            isOpen: false,
            saveUserChoice: false,
            isCalloutVisible: false,
            uploadFolderName: null,
        },
    },
};
var filePickerStore = createStore('filepicker', filePickerStoreData)();
export default filePickerStore;
//# sourceMappingURL=filePickerStore.js.map